import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"mailCancel\"><g id=\"icon\"><path id=\"Vector\" d=\"M21 12.6V6.3C21 5.82261 20.8104 5.36477 20.4728 5.02721C20.1352 4.68964 19.6774 4.5 19.2 4.5H4.8C4.32261 4.5 3.86477 4.68964 3.52721 5.02721C3.18964 5.36477 3 5.82261 3 6.3V17.1C3 18.09 3.81 18.9 4.8 18.9H12.9\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M21 7.20001L12.927 12.33C12.6491 12.5041 12.3279 12.5964 12 12.5964C11.6721 12.5964 11.3509 12.5041 11.073 12.33L3 7.20001\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M16.5 16.2L20.1 19.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_4\" d=\"M20.1 16.2L16.5 19.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }